import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

const BASE_URL = process.env.REACT_APP_API_URL


export default function VocabEditorUI() {
  const [file, setFile] = useState(null);
  const [vocab, setVocab] = useState([]);
  const [indexToEdit, setIndexToEdit] = useState('');
  const [newWord, setNewWord] = useState('');
  const [message, setMessage] = useState('');
  const [step, setStep] = useState(1);

  const resetAll = () => {
    setFile(null);
    setVocab([]);
    setIndexToEdit('');
    setNewWord('');
    setMessage('');
    setStep(1);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage('');
  };

  const uploadAndView = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);

    try {
      await axios.post(`${BASE_URL}/upload-vocab`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      const res = await axios.get(`${BASE_URL}/show-vocab`);
      const sortedVocab = Object.entries(res.data).sort((a, b) => a[0] - b[0]);
      setVocab(sortedVocab);
      setMessage('✅ Vocab loaded successfully');
      setStep(2);
    } catch (err) {
      setMessage('❌ Failed to upload or read vocab');
    }
  };

  const editWord = async () => {
    if (indexToEdit === '' || newWord === '') return;

    try {
      await axios.put(`${BASE_URL}/edit-vocab`, {
        index: parseInt(indexToEdit, 10),
        new_word: newWord
      });
      const res = await axios.get(`${BASE_URL}/show-vocab`);
      const sortedVocab = Object.entries(res.data).sort((a, b) => a[0] - b[0]);
      setVocab(sortedVocab);
      setMessage(`✅ Word at index ${indexToEdit} updated to "${newWord}"`);
      setIndexToEdit('');
      setNewWord('');
      setStep(4);
    } catch (err) {
      setMessage('❌ Failed to edit vocab');
    }
  };

  const saveVocab = async () => {
    try {
      const res = await axios.post(`${BASE_URL}/save-vocab`, {}, { responseType: 'blob' });
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'edited_vocab.pkl';
      a.click();
      setMessage('💾 Vocab saved');
    } catch (err) {
      setMessage('❌ Failed to save vocab');
    }
  };

  return (
    <div className="container">
      <h1>Vocab Editor</h1>

      {step === 1 && (
        <div className="section">
          <h2>1. Upload Vocab</h2>
          <input type="file" onChange={handleFileChange} />
          <button onClick={uploadAndView}>Upload and View</button>
        </div>
      )}

      {step === 2 && (
        <>
          <div className="section">
            <h2>2. Vocab Contents</h2>
            <div className="table-wrapper">
              <table className="table">
                <thead>
                  <tr>
                    <th>Index</th>
                    <th>Word</th>
                  </tr>
                </thead>
                <tbody>
                  {vocab.map(([index, word]) => (
                    <tr key={index}>
                      <td>{index}</td>
                      <td>{word}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="section">
            <button onClick={() => setStep(3)}>✏️ Edit Vocab</button>
            <button onClick={resetAll} className="secondary-btn">🔁 Skip</button>
          </div>
        </>
      )}

      {step === 3 && (
        <div className="section">
          <h2>3. Edit Word</h2>
          <input
            type="number"
            placeholder="Index"
            value={indexToEdit}
            onChange={(e) => setIndexToEdit(e.target.value)}
          />
          <input
            type="text"
            placeholder="New Word"
            value={newWord}
            onChange={(e) => setNewWord(e.target.value)}
          />
          <button onClick={editWord}>Update</button>
          <button
            onClick={() => setStep(2)}
            style={{ marginLeft: '10px', backgroundColor: '#ccc', color: '#333' }}
          >
            ⬅ Back
          </button>
        </div>
      )}


      {step === 4 && (
        <div className="section">
          <h2>4. Save Changes</h2>
          <button onClick={saveVocab}>💾 Save Vocab File</button>
          <button onClick={resetAll} className="secondary-btn">🔁 Start Over</button>
        </div>
      )}

      {message && <p className="message">{message}</p>}
    </div>
  );
}
